module.exports = __webpack_public_path__ + "ICONLinkedIN.svg?ad0f28fc7bc300287b05c0f7d66ee1ca";


//////////////////
// WEBPACK FOOTER
// ./static/ICONLinkedIN.svg
// module id = 85
// module chunks = 0